import { LoadingSpinner } from "components/loadingSpinner";
import { FC, useCallback, useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "redux/store";
import { Guid } from "types";
import { selectSession } from "redux/selectors";
import MD5 from "crypto-js/md5";
import { HomePage } from "pages/home";
import LoginPage from "pages/login";
import { setGuid, setIsLogged, showErrorModal } from "redux/slices";
import { passwordStorage } from "utils";

export const PasswordCheck: FC<Guid> = ({ guid }) => {
  const [passwordMatch, setPasswordMatch] = useState<boolean | undefined>(
    undefined
  );
  const dispatch = useAppDispatch();
  const { session } = useAppSelector(selectSession);

  const checkPasswordMatch = useCallback(
    (pwdToCheck: string, passwordDb: string) => {
      const cryptedPwd = MD5(pwdToCheck).toString();
      const matched = cryptedPwd.toUpperCase() === passwordDb;
      setPasswordMatch(matched);
      return matched;
    },
    []
  );

  const checkTypedPwd = async (typedPwd: string) => {
    if (session?.Pwd) {
      const matched = checkPasswordMatch(typedPwd, session?.Pwd);
      if (matched) {
        try {
          passwordStorage.set(guid, session?.Pwd);
          dispatch(setGuid(guid));
          dispatch(setIsLogged(true));
        } catch (error) {
          console.error(error);
        }
      } else {
        dispatch(
          showErrorModal({ text: "La password che hai inserito è sbagliata." })
        );
      }
    }
  };

  const checkEmptyPassword = useCallback(
    (passwordDb: string) => {
      const match = checkPasswordMatch("", passwordDb);
      dispatch(setGuid(guid));
      dispatch(setIsLogged(true));
      return match;
    },
    [checkPasswordMatch, dispatch, guid]
  );

  const retrivePasswordFromDb = useCallback(
    (passwordDb: string) => {
      const isEmptyPassowrd = checkEmptyPassword(passwordDb);
      if (!isEmptyPassowrd) {
        const storedPwd = passwordStorage.get(guid);
        const match = storedPwd === passwordDb;
        setPasswordMatch(match);
        dispatch(setGuid(guid));
        dispatch(setIsLogged(match));
      }
    },
    [checkEmptyPassword, dispatch, guid]
  );

  useEffect(() => {
    if (session?.Pwd) {
      retrivePasswordFromDb(session.Pwd);
    }
  }, [retrivePasswordFromDb, session]);

  if (passwordMatch === undefined) {
    return <LoadingSpinner />;
  }

  return passwordMatch ? (
    <HomePage />
  ) : (
    <LoginPage checkTypedPwd={checkTypedPwd} />
  );

  // if (!session?.Pwd) {
  //   return <HomePage />;
  // }
  // return null;
};
